<template>
  <div>
    <div class="w3-container">
      <div class="headerGrid w3-hide-print">
        <div>
          <header>
            <h2>Email</h2>
          </header>
        </div>
      </div>

      <!-- My Emails -->
      <emailsList></emailsList>
    </div>
  </div>
</template>

<script>
var dataStore = require("../dataStore").default
import emailsList from '@/components/emailsList'

export default {
  name: "Email",
  data() {
    return {
      state: dataStore.state,
      width: window.innerWidth
    }
  },
  components: {
    emailsList
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Email.vue